module.exports = __webpack_public_path__ + "img/Canada.8bf51ada.png";